<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'label_register_translations' | translate }}</div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>
    <form [formGroup]="form" #ngForm="ngForm">
        <div class="p-6" mat-dialog-content>
            <ng-container>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{'label_language' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <mat-select (selectionChange)="onChangeContext($event.value)" formControlName="language">
                                @for (lang of data.languageData; track lang) {
                                <mat-option [value]="lang.value"> {{ 'label_translation_' + lang.viewValue | transloco }} </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{'label_area' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <mat-select (selectionChange)="onChangeContext($event.value)" formControlName="contextId">
                                @for (context of data.contextData; track context) {
                                <mat-option [value]="context.value">
                                    {{ 'label_translation_contexts_' + context.viewValue | transloco }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{'label_name' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <input id="translationKey" [formControlName]="'translationKey'" matInput />
                            @if (form.get('translationKey').hasError('pattern') && !form.hasError('required')) {
                            <mat-error> {{ 'error_translation_contexts_input_validation' | translate }} </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <mat-form-field class="fuse-mat w-full">
                            <mat-label>{{ 'label_value' | translate}}</mat-label>
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            <input id="translationValue" [formControlName]="'translationValue'" matInput />
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
            <div class="float-left w-100 mt-2">
                <!-- Divider -->
                @if (form.get('agent')?.value) {
                <div class="mt-1 mb-1 border-t"></div>
                }
                <!-- Actions -->
                <div class="flex items-center justify-end mt-2 mb-2">
                    <button
                        class="ml-1"
                        (click)="addTranslation()"
                        mat-flat-button
                        type="submit"
                        [color]="'primary'"
                        [disabled]="!formEnabled"
                    >
                        @if (formEnabled) {
                        <span> {{ 'label_register' | translate }} </span>
                        } @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </div>
        </div>
    </form>
</span>
